import React from 'react';
import {
  FormControl as MuiFormControl,
  FormControlProps as MuiFormControlProps,
  FormHelperText,
  SxProps,
  Theme,
} from '@mui/material';

export interface FormControlProps extends Omit<MuiFormControlProps, 'error'> {
  /** Error message to display below the form control */
  errorMessage?: string;
  /** Helper text to display below the form control */
  helperText?: string;
  /** Custom styles for the form control */
  sx?: SxProps<Theme>;
}

/**
 * A wrapper component for Material-UI's `FormControl` with enhanced error handling.
 * This component automatically handles error states and helper text display.
 */
const FormControl = ({
  children,
  errorMessage,
  helperText,
  sx,
  ...rest
}: FormControlProps) => {
  const hasError = !!errorMessage;
  const displayHelperText = errorMessage || helperText;

  return (
    <MuiFormControl error={hasError} sx={sx} {...rest}>
      {children}
      {displayHelperText && (
        <FormHelperText error={hasError}>{displayHelperText}</FormHelperText>
      )}
    </MuiFormControl>
  );
};

export default FormControl;
